var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "appSetting" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "setRuleForm",
              attrs: {
                rules: _vm.rules,
                "label-width": "160px",
                model: _vm.settingForm,
                "inline-message": ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: this.$t("developer.pushDerail") } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-color": "#13ce66",
                      "inactive-color": "#cccccc"
                    },
                    model: {
                      value: _vm.settingForm.pushDerail,
                      callback: function($$v) {
                        _vm.$set(_vm.settingForm, "pushDerail", $$v)
                      },
                      expression: "settingForm.pushDerail"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { effect: "dark", placement: "bottom" }
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [_vm._v(_vm._s(_vm.$t("developer.pushIntroduce")))]
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: { color: "#606266" }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.settingForm.pushDerail === true
                ? [
                    _c("div", { staticClass: "divider_cla" }, [
                      _c("div", { staticClass: "el-divider__text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("developer.serviceConfig")) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.iSurlEg ? "successCla" : "",
                        attrs: { prop: "url", label: this.$t("developer.url") }
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: _vm.$t("developer.urlEg"),
                              autocomplete: "off"
                            },
                            on: { change: _vm.validateField },
                            model: {
                              value: _vm.settingForm.url,
                              callback: function($$v) {
                                _vm.$set(_vm.settingForm, "url", $$v)
                              },
                              expression: "settingForm.url"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "resetAppSecret_cla",
                                attrs: { slot: "append" },
                                on: { click: _vm.validateField },
                                slot: "append"
                              },
                              [_vm._v(_vm._s(_vm.$t("developer.validateUrl")))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.iSurlEg
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "@themeColor",
                                  "margin-left": "10px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.message) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "token",
                          label: this.$t("developer.token")
                        }
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticStyle: { width: "400px" },
                            attrs: {
                              autocomplete: "off",
                              placeholder: this.$t("developer.tokenPla")
                            },
                            model: {
                              value: _vm.settingForm.token,
                              callback: function($$v) {
                                _vm.$set(_vm.settingForm, "token", $$v)
                              },
                              expression: "settingForm.token"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "resetAppSecret_cla",
                                attrs: { slot: "append" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.createToken($event)
                                  }
                                },
                                slot: "append"
                              },
                              [_vm._v(_vm._s(_vm.$t("developer.randomCode")))]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            staticStyle: { "margin-left": "10px" },
                            attrs: { effect: "dark", placement: "bottom" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [_vm._v(_vm._s(_vm.$t("developer.randomNote")))]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "el-icon-info",
                              staticStyle: { color: "#606266" }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: this.$t("developer.aesStatus") } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#cccccc"
                          },
                          model: {
                            value: _vm.settingForm.aesStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.settingForm, "aesStatus", $$v)
                            },
                            expression: "settingForm.aesStatus"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.settingForm.aesStatus
                      ? [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "aesKey",
                                label: this.$t("developer.aeskey")
                              }
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    autocomplete: "off",
                                    placeholder: this.$t("developer.aeskeyPla"),
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.settingForm.aesKey,
                                    callback: function($$v) {
                                      _vm.$set(_vm.settingForm, "aesKey", $$v)
                                    },
                                    expression: "settingForm.aesKey"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "resetAppSecret_cla",
                                      attrs: { slot: "append" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.createAesKey($event)
                                        }
                                      },
                                      slot: "append"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("developer.randomCode"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { effect: "dark", placement: "bottom" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("developer.randomNote16"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "el-icon-info",
                                    staticStyle: { color: "#606266" }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "divider_cla" }, [
                      _c("div", { staticClass: "el-divider__text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("developer.eventTypeArray")) +
                            "\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { offset: 1 } },
                          [
                            _c(
                              "el-collapse",
                              {
                                model: {
                                  value: _vm.activeName,
                                  callback: function($$v) {
                                    _vm.activeName = $$v
                                  },
                                  expression: "activeName"
                                }
                              },
                              [
                                _vm._l(_vm.pushTypeData, function(item) {
                                  return [
                                    _c(
                                      "el-collapse-item",
                                      {
                                        key: item.name,
                                        staticClass: "collapse-item-cla",
                                        attrs: { name: item.name }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "title" },
                                          [
                                            _c("span", {
                                              staticClass: "collapse-block-cla"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: {
                                                  indeterminate:
                                                    item.isIndeterminate
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.handleCheckAllChange(
                                                      item
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: item.isCheckAll,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "isCheckAll",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.isCheckAll"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "collapse-title-cla"
                                                  },
                                                  [_vm._v(_vm._s(item.name))]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "push_item_cla" },
                                          [
                                            _vm._l(item.list, function(o) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    key: o.sid,
                                                    staticClass: "push_item"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "push_item_title"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              width: "280px",
                                                              overflow:
                                                                "hidden",
                                                              "text-overflow":
                                                                "ellipsis"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(o.name)
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("el-checkbox", {
                                                          attrs: {
                                                            disabled:
                                                              o.status === 0
                                                                ? true
                                                                : false
                                                          },
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              return _vm.checkedEvent(
                                                                o
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value: o.isCheck,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                o,
                                                                "isCheck",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "o.isCheck"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "push_item_des_cla"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "developer.pushDes"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              o.description
                                                            ) +
                                                            "\n                        "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      2
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item")
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { width: "100%", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#fff" },
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.submitSetting($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1cea6639", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cea6639","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appSetting/appSetting.vue
// module id = null
// module chunks = 